import { Flex, Grid } from '@radix-ui/themes';
import { TrainingPerfLegend } from 'components/sections/admin-portal/machines/dialogs/training-performance/plots/legend';
import { TrainingPerfPlotBreaks } from 'components/sections/admin-portal/machines/dialogs/training-performance/plots/plot-break-stdev';
import { TrainingPerfPlotPlate } from 'components/sections/admin-portal/machines/dialogs/training-performance/plots/plot-plate-location';
import { IItrLogExt } from 'lib_ts/interfaces/training/i-training-log';

export const TrainingPerfPlots = (props: { iterations: IItrLogExt[] }) => {
  return (
    <Flex direction="column" gap="4">
      <Grid
        columns={{
          md: '1',
          lg: '2',
        }}
        gap="4"
      >
        <TrainingPerfPlotPlate iterations={props.iterations} />
        <TrainingPerfPlotBreaks iterations={props.iterations} />
      </Grid>
      <TrainingPerfLegend />
    </Flex>
  );
};
